module.exports = __webpack_public_path__ + "img/voice-icon1.2d884e3.png";